import React, { Component } from "react";
import EditableDataContainer from "../containers/EditableDataContainer";
import ApiConfig from "../config/ApiConfig";
import { withRouterUtilities } from "../util/withRouterUtilities";
import { contentMap } from "../content/contentMap";
import { customNavigationMap } from "../config/customNavigationMap";
import { array, number, object, string } from "yup";
import RefinanceIrqConfirmationView from "../views/RefinanceIrqConfirmationView";
import { getDateFourteenDaysFromNow } from "../util/getDateFourteenDaysFromNow";
import StatusCheck from "../components/StatusCheck";

class RefinanceIrqConfirmationPage extends Component {
  render() {
    const submitEndpoint =
      ApiConfig.protocol + ApiConfig.apiUri + ApiConfig.irqEndpoint;

    const minDate = getDateFourteenDaysFromNow();

    return (
      <div className="page-wrapper">
        <StatusCheck />
        <EditableDataContainer
          id="refinanceIrq"
          submitEndpoint={submitEndpoint}
          mutateRedux="always"
          isCreate
          isStep
          validationSchema={object().shape({
            street: string().required(),
            city: string().required(),
            county: string().required(),
            state: string().required(),
            zip: string().required(),
            price: number().required().min(100).max(100_000_000),
            existingLoanBalance: number().required().min(100).max(100_000_000),
            amountOfCashOut: number().min(0).max(100_000_000),
            creditScore: number()
              .typeError("Provided value is invalid")
              .required()
              .min(300)
              .max(850),
            loanOptions: array().required().min(1),
          })}
        >
          <RefinanceIrqConfirmationView
            content={contentMap.RefinanceIrqConfirmationPage}
            navigationsAway={customNavigationMap.RefinanceIrqConfirmationPage}
          />
        </EditableDataContainer>
      </div>
    );
  }
}

export default withRouterUtilities(RefinanceIrqConfirmationPage);
